import { render } from "./NumberSection.vue?vue&type=template&id=513d6d06&scoped=true"
import script from "./NumberSection.vue?vue&type=script&lang=js"
export * from "./NumberSection.vue?vue&type=script&lang=js"

import "./NumberSection.vue?vue&type=style&index=0&id=513d6d06&scoped=true&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513d6d06"]])

export default __exports__